import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-container">
        <div className="privacy-content">
          <h1>Politique de Confidentialité</h1>
          <p className="last-updated">Dernière mise à jour : 8 janvier 2025</p>

          <section>
            <h2>1. Introduction</h2>
            <p>
              Joby ("nous", "notre", "l'application") s'engage à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre application mobile Joby.
            </p>
          </section>

          <section>
            <h2>2. Informations que nous collectons</h2>
            <h3>2.1 Informations que vous nous fournissez</h3>
            <ul>
              <li><strong>Informations de compte :</strong> Nom, adresse e-mail, numéro de téléphone</li>
              <li><strong>Informations de profil :</strong> Compétences, CV, photo de profil</li>
              <li><strong>Informations de candidature :</strong> CV téléchargé, lettres de motivation</li>
            </ul>

            <h3>2.2 Informations collectées automatiquement</h3>
            <ul>
              <li><strong>Données d'utilisation :</strong> Pages visitées, fonctionnalités utilisées, temps passé dans l'application</li>
              <li><strong>Informations sur l'appareil :</strong> Type d'appareil, système d'exploitation, identifiant unique de l'appareil</li>
              <li><strong>Données de localisation :</strong> Ville et pays (si vous les fournissez pour la recherche d'emploi)</li>
            </ul>
          </section>

          <section>
            <h2>3. Comment nous utilisons vos informations</h2>
            <p>Nous utilisons vos informations pour :</p>
            <ul>
              <li>Fournir et améliorer nos services de recherche d'emploi</li>
              <li>Traiter vos candidatures et les transmettre aux employeurs</li>
              <li>Vous envoyer des notifications concernant vos candidatures</li>
              <li>Personnaliser votre expérience dans l'application</li>
              <li>Analyser l'utilisation de l'application pour améliorer nos services</li>
              <li>Respecter nos obligations légales</li>
            </ul>
          </section>

          <section>
            <h2>4. Partage de vos informations</h2>
            <p>Nous ne vendons jamais vos informations personnelles. Nous partageons vos informations uniquement dans les cas suivants :</p>
            <ul>
              <li><strong>Avec les employeurs :</strong> Lorsque vous postulez à un emploi, nous transmettons votre CV et vos informations de contact à l'employeur concerné</li>
              <li><strong>Fournisseurs de services :</strong> Nous utilisons des services tiers (hébergement cloud, analyse) qui peuvent avoir accès à vos données dans le cadre de leurs services</li>
              <li><strong>Obligations légales :</strong> Si la loi l'exige ou pour protéger nos droits</li>
            </ul>
          </section>

          <section>
            <h2>5. Stockage et sécurité</h2>
            <p>
              Vos données sont stockées de manière sécurisée sur des serveurs cloud. Nous utilisons des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos informations contre l'accès non autorisé, la perte ou la destruction.
            </p>
            <p>
              Vos CV sont stockés sur Cloudinary, un service de stockage cloud sécurisé. Vos autres données sont stockées dans MongoDB Atlas, une base de données cloud sécurisée.
            </p>
          </section>

          <section>
            <h2>6. Publicité</h2>
            <p>
              Notre application utilise Google AdMob pour afficher des publicités. AdMob peut collecter certaines informations pour personnaliser les publicités que vous voyez. Pour plus d'informations sur les pratiques de Google AdMob, consultez la <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">politique de confidentialité de Google</a>.
            </p>
          </section>

          <section>
            <h2>7. Vos droits</h2>
            <p>Vous avez le droit de :</p>
            <ul>
              <li>Accéder à vos informations personnelles</li>
              <li>Corriger vos informations inexactes</li>
              <li>Supprimer votre compte et vos données</li>
              <li>Vous opposer au traitement de vos données</li>
              <li>Demander une copie de vos données</li>
            </ul>
            <p>
              <strong>Suppression de compte :</strong> Vous pouvez supprimer votre compte et toutes vos données associées directement depuis l'application dans les paramètres, ou en nous contactant à l'adresse indiquée ci-dessous. La suppression est permanente et irréversible.
            </p>
            <p>
              <strong>URL de suppression de compte :</strong> 
              <a href="https://joby.live/delete-account" target="_blank" rel="noopener noreferrer">https://joby.live/delete-account</a>
            </p>
            <p>
              Dans l'application, allez dans Paramètres → Privacy & Security → Delete Account, ou visitez la page web ci-dessus pour plus d'informations.
            </p>
          </section>

          <section>
            <h2>8. Cookies et technologies similaires</h2>
            <p>
              Notre application peut utiliser des cookies et des technologies similaires pour améliorer votre expérience. Vous pouvez gérer vos préférences de cookies dans les paramètres de votre appareil.
            </p>
          </section>

          <section>
            <h2>9. Enfants</h2>
            <p>
              Notre application n'est pas destinée aux enfants de moins de 13 ans. Nous ne collectons pas sciemment d'informations personnelles d'enfants de moins de 13 ans. Si vous pensez qu'un enfant a fourni des informations personnelles, contactez-nous immédiatement.
            </p>
          </section>

          <section>
            <h2>10. Modifications de cette politique</h2>
            <p>
              Nous pouvons modifier cette politique de confidentialité de temps à autre. Nous vous informerons de tout changement en publiant la nouvelle politique sur cette page et en mettant à jour la date de "Dernière mise à jour".
            </p>
          </section>

          <section>
            <h2>11. Contact</h2>
            <div className="contact-info">
              <p>Si vous avez des questions concernant cette politique de confidentialité, vous pouvez nous contacter :</p>
              <ul>
                <li><strong>E-mail :</strong> privacy@joby.live</li>
                <li><strong>Site web :</strong> <a href="https://joby.live">https://joby.live</a></li>
              </ul>
            </div>
          </section>

          <section>
            <h2>12. Conformité</h2>
            <p>
              Cette politique de confidentialité est conforme au Règlement Général sur la Protection des Données (RGPD) de l'Union Européenne et aux lois applicables sur la protection des données.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

